<script>
    export let percentage;
    export let onRestart = () => {};  // Provide a default empty function in case it's not passed
</script>

<div class="results-container">
    <h2>Congratulations!</h2>
    <p>You're <span class="percentage">{percentage}%</span> human.</p>
    <button class="restart-button" on:click={onRestart}>Play Again</button>
</div>

<style>
    .results-container {
        display: flex;
        flex-direction: column;
        align-items: center; /* horizontally center in a column flexbox */
        justify-content: center; /* vertically center */
        height: 100vh; /* full viewport height */
        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; /* use a nice font */
        background-color: #f7f9fc; /* soft background color */
        color: #333; /* text color */
        text-align: center; /* center-aligned text */
    }

    h2 {
        font-size: 2.5em;
        margin-bottom: 0.5em;
        color: #4a90e2; /* give the header a soft blue color */
    }

    p {
        font-size: 1.5em;
    }

    .percentage {
        font-weight: bold;
        color: #e94e77; /* make the percentage stand out with a soft red color */
    }

    .restart-button {
        margin-top: 1em;
        padding: 0.5em 1em;
        font-size: 1em;
        cursor: pointer;
        border: none;
        border-radius: 5px;
        background-color: #4a90e2;
        color: white;
        transition: background-color 0.3s;

        &:hover {
            background-color: #357ab7;
        }
    }
</style>
